import React from 'react';
import { TextField, FormHelperText, MenuItem, Typography } from '@mui/material';

function RenderTextField({ input, meta: { invalid, touched, error, active }, ...custom }) {
	if (custom.select && custom.inputdata.disableEmptyOption) {
		return (
			<div>
				<TextField
					{...input}
					id={custom.inputdata.id}
					name={custom.inputdata.name}
					label={custom.inputdata.label}
					placeholder={custom.inputdata.placeholder}
					fullWidth
					variant="outlined"
					disabled={custom.inputdata.readonly}
					SelectProps={{
						disabled: false,
						className: custom.inputdata.readonly ? 'Mui-disabled' : '',
					}}
					InputProps={{
						disabled: custom.inputdata.readonly,
						readOnly: custom.inputdata.readonly,
						style: custom.inputdata.readonly ? { pointerEvents: 'none' } : {},
					}}
					error={touched && invalid && !active}
					helperText={touched && !active && error}
					onChange={(event) => {
						let value = event.target.value;

						if (custom.inputdata.type === 'number') {
							const regex = /^[0-9-]*$/;
							if (!regex.test(value)) return;
						}

						input.onChange(value);
						if (typeof custom.inputdata.onChange !== 'undefined') {
							custom.inputdata.onChange(value);
						}
					}}
          type={custom.inputdata.type === 'number' ? 'text' : custom.inputdata.type}
					size={custom.inputdata.size ? custom.inputdata.size : null}
					{...custom}
					inputProps={{
						step: custom.inputdata.props ? custom.inputdata.props.step : null,
						min: custom.inputdata.props ? custom.inputdata.props.min : null,
						maxLength: custom.inputdata.props ? custom.inputdata.props.maxLength : null,
						className: custom.inputdata.disableNumberArrows ? 'number-input' : null,
            inputMode: custom.inputdata.type === 'number' ? 'numeric' : undefined,
					}}
				>
					{custom.inputdata.type === 'select' &&
						custom.inputdata.options &&
						custom.inputdata.options.map((option) => (
							<MenuItem key={option.value} value={option.value}>
								{option.label}
							</MenuItem>
						))}
				</TextField>
				<FormHelperText id="my-helper-text"> {custom.inputdata.helperText}</FormHelperText>
			</div>
		);
	} else {
		return (
			<div>
				{custom.inputdata.title && <Typography>{custom.inputdata.title}</Typography>}
				<TextField
					{...input}
					id={custom.inputdata.id}
					name={custom.inputdata.name}
					label={custom.inputdata.label}
					placeholder={custom.inputdata.placeholder}
					fullWidth
					variant="outlined"
					disabled={custom.inputdata.readonly}
					SelectProps={{
						disabled: false,
						className: custom.inputdata.readonly ? 'Mui-disabled' : '',
					}}
					InputProps={{
						disabled: custom.inputdata.readonly,
						readOnly: custom.inputdata.readonly,
						style: custom.inputdata.readonly ? { pointerEvents: 'none' } : {},
					}}
					error={touched && invalid && !active}
					helperText={touched && !active && error}
					onChange={(event) => {
						let value = event.target.value;

						if (custom.inputdata.type === 'number') {
							const regex = /^[0-9-]*$/;
							if (!regex.test(value)) return;
						}

						input.onChange(value);
						if (typeof custom.inputdata.onChange !== 'undefined') {
							custom.inputdata.onChange(value);
						}
					}}
					type={custom.inputdata.type === 'number' ? 'text' : custom.inputdata.type}
					size={custom.inputdata.size ? custom.inputdata.size : null}
					{...custom}
					inputProps={{
						step: custom.inputdata.props ? custom.inputdata.props.step : null,
						min: custom.inputdata.props ? custom.inputdata.props.min : null,
						maxLength: custom.inputdata.props ? custom.inputdata.props.maxLength : null,
						className: custom.inputdata.disableNumberArrows ? 'number-input' : null,
            inputMode: custom.inputdata.type === 'number' ? 'numeric' : undefined,
					}}
				/>
				<FormHelperText id="my-helper-text"> {custom.inputdata.helperText}</FormHelperText>
			</div>
		);
	}
}

export default RenderTextField;
